import { AriaToastRegionProps } from '@react-aria/toast';
import { ToastOptions, ToastQueue, useToastQueue } from '@react-stately/toast';
import { createPortal, flushSync } from 'react-dom';
import ToastRegion from '~/components/data-display/Toast/ToastRegion';
import { ToastInfo } from '~/types/toast';

const toastQueue = new ToastQueue<ToastInfo>({
  maxVisibleToasts: 3,
  wrapUpdate(fn) {
    if ('startViewTransition' in document) {
      document.startViewTransition(() => {
        flushSync(fn);
      });
    } else {
      fn();
    }
  },
});

export const snack = {
  enqueue: (toastInfo: ToastInfo, options?: ToastOptions) => toastQueue.add(toastInfo, options),
  success: (message: string) => toastQueue.add({ type: 'success', message }, { timeout: 3000 }),
  error: (message: string) => toastQueue.add({ type: 'error', message }, { timeout: 5000 }),
  warning: (message: string) => toastQueue.add({ type: 'warning', message }, { timeout: 3000 }),
  info: (message: string) => toastQueue.add({ type: 'info', message }, { timeout: 3000 }),
  default: (message: string) => toastQueue.add({ type: 'neutral', message }, { timeout: 3000 }),
  loading: (message: string) => toastQueue.add({ type: 'loading', message }, { timeout: 3000 }),
  close: (key: string) => toastQueue.close(key),
  clearAll: () => toastQueue.clear(),
} as const;

const ToastProvider: React.FC<AriaToastRegionProps> = (props) => {
  const state = useToastQueue(toastQueue);

  return state.visibleToasts.length > 0 ? createPortal(<ToastRegion {...props} state={state} />, document.body) : null;
};

export default ToastProvider;
